// src/services/driveractivityplanning.js
import axiosClient from '../configs/axios';

class DriverActivityPlaning {
  async getactivitychallannoList({ cust_id, page = 0, size = 999, searchKey = '' }) {
    try {
      const response = await axiosClient.get(
        `driver_activity_planning/challan?cust_id=${cust_id}&page=${page}&size=${size}&searchKey=${searchKey}`
      );
      return response.data; // Expected: array of objects with invoice_no (e.g., [{ invoice_no: "r444" }, ...])
    } catch (error) {
      console.error('Error fetching challan numbers:', error);
      throw error;
    }
  }


    async getDriverActivityList({  page = 0, size = 9999999, searchKey = '' }) {
    try {
      const response = await axiosClient.get(
        `driver_activity_planning/list?&page=${page}&size=${size}&searchKey=${searchKey}`
      );
      return response.data; 
    } catch (error) {
      console.error('', error);
      throw error;
    }
  }
    async adddriveractivity(data) {
          try {
              const response = await axiosClient.post('/driver_activity_planning/add', data);
              return response.data;
          } catch (error) {
              throw error;
          }
      }
  
}



export default new DriverActivityPlaning();